var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择油站:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "请选择",
                        clearable: ""
                      },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.activityName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "activityName", $$v)
                      },
                      expression: "searchInfo.activityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.activityStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "activityStatus", $$v)
                        },
                        expression: "searchInfo.activityStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "启用", value: 1 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "禁用", value: 2 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "审核状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.auditStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "auditStatus", $$v)
                        },
                        expression: "searchInfo.auditStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 1, attrs: { label: "待审核", value: 1 } },
                        [_vm._v("待审核")]
                      ),
                      _c(
                        "el-option",
                        { key: 2, attrs: { label: "通过", value: 2 } },
                        [_vm._v("通过")]
                      ),
                      _c(
                        "el-option",
                        { key: 3, attrs: { label: "不通过", value: 3 } },
                        [_vm._v("不通过")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.onAdd }
                    },
                    [_vm._v("新增规则")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { label: "活动编号", prop: "activityNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "activityName" }
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", prop: "dateStart" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", prop: "dateEnd" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "活动状态", prop: "activityStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warn", effect: "plain" } },
                          [_vm._v("待审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("审核不通过")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("已启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2 && scope.row.activityStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "error", effect: "plain" } },
                          [_vm._v("已禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onUpdate(scope.row)
                              }
                            }
                          },
                          [_vm._v("变更")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAudit(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onAble(scope.row)
                              }
                            }
                          },
                          [_vm._v("启用")]
                        )
                      : _vm._e(),
                    scope.row.auditStatus == 2
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onDisable(scope.row)
                              }
                            }
                          },
                          [_vm._v("禁用")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.viewDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-point-activity bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动名称：" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formData.activityName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.activityName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动时间：" } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetimerange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "开始(含当天)",
                                      "end-placeholder": "结束(含当天)",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss"
                                    },
                                    model: {
                                      value: _vm.dateRangeValueArr,
                                      callback: function($$v) {
                                        _vm.dateRangeValueArr = $$v
                                      },
                                      expression: "dateRangeValueArr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "可积分订单:" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formData.sellerOrderType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "sellerOrderType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.sellerOrderType"
                                      }
                                    },
                                    [
                                      _vm._l(
                                        _vm.sellerOrderTypeOptions,
                                        function(item) {
                                          return [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: item.value } },
                                              [_vm._v(_vm._s(item.label))]
                                            )
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动油站:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.stationCheckAll,
                                        callback: function($$v) {
                                          _vm.stationCheckAll = $$v
                                        },
                                        expression: "stationCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.stationIdChecked,
                                        callback: function($$v) {
                                          _vm.stationIdChecked = $$v
                                        },
                                        expression: "stationIdChecked"
                                      }
                                    },
                                    _vm._l(_vm.stationOptions, function(item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.ID,
                                          attrs: { label: item.ID }
                                        },
                                        [_vm._v(_vm._s(item.stationName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动油品:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.oilCodesCheckAll,
                                        callback: function($$v) {
                                          _vm.oilCodesCheckAll = $$v
                                        },
                                        expression: "oilCodesCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.oilCodesChecked,
                                        callback: function($$v) {
                                          _vm.oilCodesChecked = $$v
                                        },
                                        expression: "oilCodesChecked"
                                      }
                                    },
                                    _vm._l(_vm.oilCodesOptions, function(oil) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: oil.value,
                                          attrs: { label: oil.value }
                                        },
                                        [_vm._v(_vm._s(oil.label))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "支付方式:" } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: _vm.payChannelCheckAll,
                                        callback: function($$v) {
                                          _vm.payChannelCheckAll = $$v
                                        },
                                        expression: "payChannelCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.payChannelChecked,
                                        callback: function($$v) {
                                          _vm.payChannelChecked = $$v
                                        },
                                        expression: "payChannelChecked"
                                      }
                                    },
                                    _vm._l(_vm.payChannelOptions, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.payChannel,
                                          attrs: { label: item.payChannel }
                                        },
                                        [_vm._v(_vm._s(item.cnName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "出资方:" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formData.capitalId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "capitalId",
                                            $$v
                                          )
                                        },
                                        expression: "formData.capitalId"
                                      }
                                    },
                                    [
                                      _vm._l(_vm.capitalOptions, function(
                                        item
                                      ) {
                                        return [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: item.capitalId }
                                            },
                                            [_vm._v(_vm._s(item.capitalName))]
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "满额/升:" } },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.formData.limitType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitType",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额")]
                                          ),
                                          _vm.formData.sellerOrderType == 1
                                            ? _c(
                                                "el-radio",
                                                { attrs: { label: 2 } },
                                                [_vm._v("满升")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.formData.limitType == 1
                                    ? _c(
                                        "el-row",
                                        [
                                          _vm._v(" 满  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.limitNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitNum"
                                            }
                                          }),
                                          _vm._v("  元可积分     每  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.everyNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "everyNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.everyNum"
                                            }
                                          }),
                                          _vm._v("  元     赠送  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.point,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "point",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.point"
                                            }
                                          }),
                                          _vm._v("  积分 ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.formData.limitType == 2
                                    ? _c(
                                        "el-row",
                                        [
                                          _vm._v(" 满  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.limitNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitNum"
                                            }
                                          }),
                                          _vm._v("  升可积分     每  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.everyNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "everyNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.everyNum"
                                            }
                                          }),
                                          _vm._v("  升     赠送  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.point,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "point",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.point"
                                            }
                                          }),
                                          _vm._v("  积分 ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审核结果：" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("待审核")
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "审核意见：" } },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: "5" },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.addDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-point-activity bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.getRule,
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动名称：",
                                    prop: "activityName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入" },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.activityName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.activityName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动时间：",
                                    prop: "dateRangeValueArr"
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "datetimerange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "开始(含当天)",
                                      "end-placeholder": "结束(含当天)",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss"
                                    },
                                    model: {
                                      value: _vm.dateRangeValueArr,
                                      callback: function($$v) {
                                        _vm.dateRangeValueArr = $$v
                                      },
                                      expression: "dateRangeValueArr"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "可积分订单:",
                                    prop: "sellerOrderType"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: _vm.onChangeSellerOrderType
                                      },
                                      model: {
                                        value: _vm.formData.sellerOrderType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "sellerOrderType",
                                            $$v
                                          )
                                        },
                                        expression: "formData.sellerOrderType"
                                      }
                                    },
                                    [
                                      _vm._l(
                                        _vm.sellerOrderTypeOptions,
                                        function(item) {
                                          return [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: item.value } },
                                              [_vm._v(_vm._s(item.label))]
                                            )
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "活动油站:",
                                    prop: "stationIdChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: _vm.handleStationCheckAllChange
                                      },
                                      model: {
                                        value: _vm.stationCheckAll,
                                        callback: function($$v) {
                                          _vm.stationCheckAll = $$v
                                        },
                                        expression: "stationCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change: _vm.handleCheckedStationChange
                                      },
                                      model: {
                                        value: _vm.stationIdChecked,
                                        callback: function($$v) {
                                          _vm.stationIdChecked = $$v
                                        },
                                        expression: "stationIdChecked"
                                      }
                                    },
                                    _vm._l(_vm.stationOptions, function(item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.ID,
                                          attrs: { label: item.ID }
                                        },
                                        [_vm._v(_vm._s(item.stationName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.formData.sellerOrderType == 1
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "bairun-required",
                                      attrs: {
                                        label: "活动油品:",
                                        prop: "oilCodesChecked"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: _vm.handleOilCheckAllChange
                                          },
                                          model: {
                                            value: _vm.oilCodesCheckAll,
                                            callback: function($$v) {
                                              _vm.oilCodesCheckAll = $$v
                                            },
                                            expression: "oilCodesCheckAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change:
                                              _vm.handleCheckedOilCodesChange
                                          },
                                          model: {
                                            value: _vm.oilCodesChecked,
                                            callback: function($$v) {
                                              _vm.oilCodesChecked = $$v
                                            },
                                            expression: "oilCodesChecked"
                                          }
                                        },
                                        _vm._l(_vm.oilCodesOptions, function(
                                          oil
                                        ) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: oil.value,
                                              attrs: { label: oil.value }
                                            },
                                            [_vm._v(_vm._s(oil.label))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "支付方式:",
                                    prop: "payChannelChecked"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change:
                                          _vm.handlePayChannelCheckAllChange
                                      },
                                      model: {
                                        value: _vm.payChannelCheckAll,
                                        callback: function($$v) {
                                          _vm.payChannelCheckAll = $$v
                                        },
                                        expression: "payChannelCheckAll"
                                      }
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      on: {
                                        change:
                                          _vm.handleCheckedPayChannelChange
                                      },
                                      model: {
                                        value: _vm.payChannelChecked,
                                        callback: function($$v) {
                                          _vm.payChannelChecked = $$v
                                        },
                                        expression: "payChannelChecked"
                                      }
                                    },
                                    _vm._l(_vm.payChannelOptions, function(
                                      item
                                    ) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.payChannel,
                                          attrs: { label: item.payChannel }
                                        },
                                        [_vm._v(_vm._s(item.cnName))]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: { label: "出资方:", prop: "capitalId" }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formData.capitalId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "capitalId",
                                            $$v
                                          )
                                        },
                                        expression: "formData.capitalId"
                                      }
                                    },
                                    [
                                      _vm._l(_vm.capitalOptions, function(
                                        item
                                      ) {
                                        return [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: { label: item.capitalId }
                                            },
                                            [_vm._v(_vm._s(item.capitalName))]
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "满额/升:",
                                    prop: "limitType"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.formData.limitType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "limitType",
                                                $$v
                                              )
                                            },
                                            expression: "formData.limitType"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("满金额")]
                                          ),
                                          _vm.formData.sellerOrderType == 1
                                            ? _c(
                                                "el-radio",
                                                { attrs: { label: 2 } },
                                                [_vm._v("满升")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.formData.limitType == 1
                                    ? _c(
                                        "el-row",
                                        [
                                          _vm._v(" 满  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.limitNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitNum"
                                            }
                                          }),
                                          _vm._v("  元可积分     每  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.everyNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "everyNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.everyNum"
                                            }
                                          }),
                                          _vm._v("  元     赠送  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.point,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "point",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.point"
                                            }
                                          }),
                                          _vm._v("  积分 ")
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.formData.limitType == 2
                                    ? _c(
                                        "el-row",
                                        [
                                          _vm._v(" 满  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.limitNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "limitNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.limitNum"
                                            }
                                          }),
                                          _vm._v("  升可积分     每  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.everyNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "everyNum",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.everyNum"
                                            }
                                          }),
                                          _vm._v("  升     赠送  "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "150px" },
                                            attrs: { controls: false },
                                            model: {
                                              value: _vm.formData.point,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "point",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.point"
                                            }
                                          }),
                                          _vm._v("  积分 ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.auditDialogVisible,
            title: _vm.dialogTitle,
            "custom-class":
              "bairun-dialog bairun-dialog-audit bairun-dialog-body-autoscroll"
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")]),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formData",
                      attrs: { model: _vm.formData, "label-position": "right" }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    label: "审核结果：",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "small" },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("通过")
                                      ]),
                                      _c("el-radio", { attrs: { label: 3 } }, [
                                        _vm._v("不通过")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审核意见：",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入",
                                      rows: "5"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.inputChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 4 } }, [_vm._v(" ")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("提 交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }